import axiosInstance from '../axiosConfigCMS';

export default {
  async getLogin() {
    const response = await axiosInstance.get('/login');
    return response.data;
  },
  async getContent() {
    const response = await axiosInstance.get('/guest-purchase');
    return response.data;
  },
};
